import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getProgramCodes } from '@api/lookups';
import { IProgramCode } from '@interfaces/programCodes';

export const handleGetProgramCodes = createAsyncThunk<AxiosResponse<IProgramCode[]>, void>(
  'getProgramCodes',
  getProgramCodes,
);
